// src/components/BasicInfoCard.js
import React from "react";

const BasicInfoCard = ({ quotation }) => (
  <div className="bg-white dark:bg-gray-800 shadow rounded p-6 mb-6 border border-gray-100 dark:border-gray-700 transition-colors duration-300">
    <h2 className="text-xl font-semibold text-gray-800 dark:text-gray-100 mb-4">
      Basic Information
    </h2>

    <div className="grid grid-cols-2 gap-4 text-sm text-gray-800 dark:text-gray-200">
      <p>
        <span className="font-bold text-gray-900 dark:text-gray-100">Title:</span>{" "}
        {quotation.title || "N/A"}
      </p>
      <p>
        <span className="font-bold text-gray-900 dark:text-gray-100">Client:</span>{" "}
        {quotation.client || "N/A"}
      </p>
      <p>
        <span className="font-bold text-gray-900 dark:text-gray-100">Create By:</span>{" "}
        {quotation.salePerson || "N/A"}
      </p>
      <p>
        <span className="font-bold text-gray-900 dark:text-gray-100">Document Date:</span>{" "}
        {quotation.documentDate
          ? new Date(quotation.documentDate).toLocaleDateString("en-GB")
          : "N/A"}
      </p>
      <p>
        <span className="font-bold text-gray-900 dark:text-gray-100">Product Name:</span>{" "}
        {quotation.productName || "N/A"}
      </p>
      <p>
        <span className="font-bold text-gray-900 dark:text-gray-100">Project Name:</span>{" "}
        {quotation.projectName || "N/A"}
      </p>
      <p>
        <span className="font-bold text-gray-900 dark:text-gray-100">Period:</span>{" "}
        {quotation.period || "N/A"}
      </p>

      <p>
        <span className="font-bold text-gray-900 dark:text-gray-100">Status:</span>
        <span
          className={`ml-2 px-2 py-0.5 rounded text-xs font-medium transition-colors duration-300
            ${
              quotation.approvalStatus === "Approved"
                ? "bg-green-100 text-green-800 dark:bg-green-900/40 dark:text-green-300"
                : quotation.approvalStatus === "Pending"
                ? "bg-yellow-100 text-yellow-800 dark:bg-yellow-900/40 dark:text-yellow-300"
                : quotation.approvalStatus === "Rejected"
                ? "bg-red-100 text-red-800 dark:bg-red-900/40 dark:text-red-300"
                : quotation.approvalStatus === "Canceled"
                ? "bg-gray-200 text-gray-800 dark:bg-gray-800 dark:text-gray-300"
                : "bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-300"
            }`}
        >
          {quotation.approvalStatus || "N/A"}
        </span>
      </p>

      <p>
        <span className="font-bold text-gray-900 dark:text-gray-100">Credit Term:</span>{" "}
        {quotation.CreditTerm ? `${quotation.CreditTerm} days` : "N/A"}
      </p>
      <p>
        <span className="font-bold text-gray-900 dark:text-gray-100">Remark:</span>{" "}
        {quotation.remark || "N/A"}
      </p>
    </div>
  </div>
);

export default BasicInfoCard;
